/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NetworkStatusTimespan { 
    data: NetworkStatusTimespan.DataEnum;
    endDate?: string;
    startDate?: string;
}
export namespace NetworkStatusTimespan {
    export const DataEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type DataEnum = typeof DataEnum[keyof typeof DataEnum];
}


